import HtmlToReact from 'html-to-react';
import React, { FunctionComponent } from 'react';
import { InterpolateEntries } from './types';

export interface InterpolateEntry {
  selector: string;
  element: FunctionComponent<any>;
  elementProps: any;
}

const htmlToReactParser = new HtmlToReact.Parser(React);
const processNodeDefinitions = new HtmlToReact.ProcessNodeDefinitions(React);

const buildInterpolateEntries = (entries: InterpolateEntry[]): [string, JSX.Element][] => (
  entries.map((e, i) => {
    const CustomElement = e.element;
    return [e.selector, <CustomElement key={`${e.selector}_${i}`} {...e.elementProps} />];
  })
);

const buildInstructions = (entries: InterpolateEntries) => {
  const processingInstructions = [];

  entries.forEach((e) => processingInstructions.push({
    shouldProcessNode: (node: any) => node.name === e[0],
    processNode: () => e[1],
    replaceChildren: true,
  }));

  // Anything else
  processingInstructions.push({
    shouldProcessNode: () => true,
    processNode: processNodeDefinitions.processDefaultNode,
    replaceChildren: false,
  });

  return processingInstructions;
};

export const interpolateContentToJSX = (content: string, entries: InterpolateEntry[]): JSX.Element[] => {
  if (!content.length) {
    return [];
  }

  const interpolateEntries = buildInterpolateEntries(entries);
  return htmlToReactParser.parseWithInstructions(content, () => true, buildInstructions(interpolateEntries));
};

export const conditionalEntries = (condition: boolean, ...elements: any): any => (condition ? elements : []);
